import(/* webpackMode: "eager" */ "/vercel/path0/apps/tuning-bytes/app/global-error.tsx");
